import React from 'react';
import { DeviceTableToolbarAddButton } from '@/features/devices/components/device-tree-table/device-table-toolbar-add-button.tsx';
import { DeviceTableToolbarEditButton } from '@/features/devices/components/device-tree-table/device-table-toolbar-edit-button.tsx';
import { DeviceTableToolbarDeleteButton } from '@/features/devices/components/device-tree-table/device-table-toolbar-delete-button.tsx';
import { ExpandedState, Row, RowData, RowSelectionState } from '@tanstack/react-table';
import { TTreeDevice } from '@/features/devices/schemas/devices.schemas.ts';

export const DeviceTableToolbar = ({
  data,
  deviceInfo,
  hasSelectedRow,
  getSelectedTableRow,
  getSelectedDevice,
  setData,
  setExpandedRows,
  setSelectedRows,
}: {
  data: TTreeDevice[];
  deviceInfo: {
    companyId: string;
    plantId: string;
    timezone: string;
  };
  hasSelectedRow: boolean;
  getSelectedTableRow: () => Row<RowData> | undefined;
  getSelectedDevice: () => TTreeDevice | null;
  setData: (devices: TTreeDevice[]) => void;
  setExpandedRows: React.Dispatch<React.SetStateAction<ExpandedState>>;
  setSelectedRows: React.Dispatch<React.SetStateAction<RowSelectionState>>;
}) => {
  return (
    <div className="flex bg-gray-50">
      <DeviceTableToolbarAddButton
        data={data}
        deviceInfo={deviceInfo}
        getSelectedTableRow={getSelectedTableRow}
        setData={setData}
        setExpandedRows={setExpandedRows}
      />
      <DeviceTableToolbarEditButton
        data={data}
        deviceInfo={deviceInfo}
        hasSelectedRow={hasSelectedRow}
        getSelectedTableRow={getSelectedTableRow}
        getSelectedDevice={getSelectedDevice}
        setData={setData}
        setSelectedRows={setSelectedRows}
      />
      <DeviceTableToolbarDeleteButton
        data={data}
        hasSelectedRow={hasSelectedRow}
        getSelectedTableRow={getSelectedTableRow}
        getSelectedDevice={getSelectedDevice}
        setData={setData}
        setExpandedRows={setExpandedRows}
        setSelectedRows={setSelectedRows}
      />
    </div>
  );
};
